var CODE_BLOCKS_REGEX = /^(([ \t]*`{3,4})([^\n]*)([\s\S]+?)(^[ \t]*\2))/gm;
var LESS_THAN_CHARS = "&#60;";

function fn(str) {
  return str.replace(CODE_BLOCKS_REGEX, function (occurrence) {
    return occurrence.replace(/</gm, LESS_THAN_CHARS);
  });
}

export var replaceAllLessThanChars = function replaceAllLessThanChars(_a) {
  var source = _a.source;
  return fn(source.content || source.rawContent);
};